// 命名規則建議
// 以客製統編開頭
// 以下不要放註釋
module.exports = {
  '56676244.ot.check.limit': {
    'code450': '超出可加班限制次數',
  },
  '56676244.leave.limit.apply': {
    'code451': '需於請假 <%= A %>工作天前 提出申請',
    'code452': '需於請假 <%= A %>曆日前 提出申請',
  },
  '56676244.leave.limit.approve': {
    'code451': '需於請假 <%= A %>工作天前 簽核完成',
    'code452': '需於請假 <%= A %>曆日前 簽核完成',
  },
  '56676244.leave.error': {
    'code459': '非預期性錯誤',
  },
};
